import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from '../../../../app.service';
import { LogT } from '../../interfaces/log';
import { LogDialogComponent } from './components/log-dialog/log-dialog.component';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss']
})
export class LogsComponent implements OnInit {

  logs: Array<LogT>;
  singleLog: string;
  constructor(public app: AppService, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.app.getLogs('').then((logs: LogT[]) => {
      console.log(logs);
      this.logs = logs;
    })
  }

  async openLog(logName: string) {
    const logDoc = await this.app.getLogs(logName).then((singleLog: {log: string}) => {
      // this.singleLog = singleLog.log;
      return singleLog.log;
    });

    const dialogRef = this.dialog.open(LogDialogComponent, {
      width: '90vw',
      height: '70vh',
      data: {name: logName, log: logDoc}
    });
  }

}
